import React from "react";
import { clsx } from "clsx";
import { Button } from "react-bootstrap";
import styles from "../llm-summary.module.scss";
import Typography from "../../../../../../../components/typography/Typography";

type LLMSummaryFeedbackButtonProps = {
  onClick: () => void;
};

const LLMSummaryFeedbackButton: React.FunctionComponent<
  LLMSummaryFeedbackButtonProps
> = ({ onClick }) => (
  <Button onClick={onClick} className={styles.llm_feedback_sidebar_button}>
    <Typography
      variant={"body1"}
      className={clsx(styles.llm_feedback_sidebar_button_text, "text-white")}
    >
      Feedback
    </Typography>
  </Button>
);

export default LLMSummaryFeedbackButton;
